import React from 'react';
import {createTheme, StyledEngineProvider, ThemeProvider} from '@mui/material/styles';
import {nbNO} from '@mui/material/locale';

export const theme = createTheme(
    {
        palette: {
            primary: {
                main: "#285238",
                light: "#417554",
                dark: "#173623",
                contrastText: "#FFFFFF",
            },
            secondary: {
                main: "#D97746",
                light: "#E2946D",
                dark: "#B35527",
                contrastText: "#FFFFFF",
            },
            background: {
                default: "#FAF8F5",
                paper: "#FFFFFF",
            },
            text: {
                primary: "#1E293B",
                secondary: "#5B6777",
            },
            divider: "#EAE6DF",
        },
        shape: {
            borderRadius: 12,
        },
        typography: {
            fontFamily: [
                'Plus Jakarta Sans',
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
            ].join(','),
            h4: {
                fontWeight: 700,
            },
            h5: {
                fontWeight: 600,
            },
            h6: {
                fontWeight: 600,
            },
            body1: {
                lineHeight: 1.7,
            },
        },
        components: {
            MuiPaper: {
                defaultProps: {
                    elevation: 0,
                },
                styleOverrides: {
                    root: {
                        border: "1px solid #EAE6DF",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                    },
                },
            },
            MuiCard: {
                defaultProps: {
                    elevation: 0,
                },
                styleOverrides: {
                    root: {
                        border: "1px solid #EAE6DF",
                        borderRadius: 12,
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 8,
                        textTransform: "none",
                        fontWeight: 600,
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    },
                },
            },
        },
    },
    nbNO
);

export const MyTheme = ({children}) => {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};